/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description accounts search fields meta
 */

const FIELDS_META: Record<keyof Guarantor.IFormModel, { title: string; placeholder: string; errorMessage?: string }> = {
	guarantorName: {
		title: 'Guarantor',
		placeholder: 'E.g.: Jonathon Vega',
		errorMessage: 'Please enter a valid guarantor name',
	},
	address: {
		title: 'Address',
		placeholder: 'E.g.: 123 Main St',
	},
	city: {
		title: 'City',
		placeholder: 'E.g.: Chicago',
	},
	state: {
		title: 'State',
		placeholder: 'E.g.: Illinois',
	},
	zipCode: {
		title: 'Zip Code',
		placeholder: 'E.g.: 842001',
	},
	cellPhone: {
		title: 'Cell Phone',
		placeholder: 'E.g.: 1234567890',
	},
	workPhone: {
		title: 'Work Phone',
		placeholder: 'E.g.: 1234567890',
	},
	email: {
		title: 'Email',
		placeholder: 'E.g.: jonathon.vega@gmail.com',
	},
	preferredContactMethod: {
		title: 'Preferred Contact Method',
		placeholder: 'E.g.: Email',
	},
};

export { FIELDS_META };
